import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle, MapPin } from "@phosphor-icons/react";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTracking = () => {
    const element = document.querySelector("#tracking");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center bg-white hero-overlay pt-20"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="order-2 lg:order-1">
            <div className="space-y-6">
              {/* Label */}
              <div className="inline-flex items-center gap-2 bg-slate-50 border border-slate-200 px-4 py-2">
                <MapPin weight="fill" className="w-4 h-4 text-[#0B2F6B]" />
                <span className="text-xs tracking-[0.15em] uppercase font-bold text-[#0B2F6B]">
                  Lakeway, Texas
                </span>
              </div>

              {/* Main Headline */}
              <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-black uppercase text-[#1A1A2E] leading-[0.95]">
                Expert
                <br />
                <span className="text-[#7A7D82]">Laser</span>
                <br />
                Repair
              </h1>

              {/* Subheadline */}
              <p className="text-lg text-slate-600 leading-relaxed max-w-lg">
                Trusted by medical spas and dermatology clinics across the nation.
                We repair all cosmetic laser brands with precision and care.
              </p>

              {/* Features */}
              <div className="flex flex-col sm:flex-row gap-4 text-sm">
                {["All Major Brands", "Fast Turnaround", "90-Day Warranty"].map(
                  (feature) => (
                    <div
                      key={feature}
                      className="flex items-center gap-2 text-slate-700"
                    >
                      <CheckCircle
                        weight="fill"
                        className="w-5 h-5 text-[#0B2F6B] flex-shrink-0"
                      />
                      <span className="font-medium">{feature}</span>
                    </div>
                  )
                )}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button
                  onClick={scrollToContact}
                  className="btn-primary bg-[#1E88FF] hover:bg-[#1976D2] text-white rounded-none px-8 py-6 text-base font-semibold"
                  data-testid="hero-cta-button"
                >
                  Request a Quote
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
                <Button
                  onClick={scrollToTracking}
                  variant="outline"
                  className="rounded-none px-8 py-6 text-base font-semibold border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"
                  data-testid="hero-track-button"
                >
                  Track Your Repair
                </Button>
              </div>
            </div>
          </div>

          {/* Right - Two Machines Side by Side */}
          <div className="order-1 lg:order-2">
            <div className="bg-slate-50 p-6 lg:p-8">
              <div className="flex flex-col sm:flex-row gap-6 items-center justify-center">
                {/* Cutera Machine */}
                <img
                  src="https://customer-assets.emergentagent.com/wingman/9c19584c-47ce-4fca-a14b-ad011323fd33/attachments/71c981c3ca97455ebbde6f33f6cd170e_images-1.jpg"
                  alt="Cutera Laser Device"
                  className="w-full sm:w-1/2 h-[250px] lg:h-[350px] object-contain"
                  data-testid="hero-image-cutera"
                />
                {/* Sciton Joule Machine */}
                <img
                  src="https://customer-assets.emergentagent.com/wingman/9c19584c-47ce-4fca-a14b-ad011323fd33/attachments/82d59c33b0ae4d52942b7d714d249a5f_images-2.jpg"
                  alt="Sciton Joule Laser Device"
                  className="w-full sm:w-1/2 h-[250px] lg:h-[350px] object-contain"
                  data-testid="hero-image-sciton"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
